import { useMemo } from 'react';
import { observer } from 'mobx-react';
import ToYouDisabledPicker from './ToYouDisabledPicker';
import ToYouEnabledPicker from './ToYouEnabledPicker';
import { ITakerBranch } from '~/types/integrations';
import { formatBranchLabel } from '~/utils/helpers';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import t360IntegrationStore from '~/view/screens/SettingsScreen/store/t360IntegrationStore';
import { RELEASES } from '~/constants/main';
import './style.scss';

interface IProps {
  takerBranch: ITakerBranch | null;
}

const ToYouPicker: React.FC<IProps> = observer(({ takerBranch }) => {
  if (!takerBranch) {
    return null;
  }

  const toYouBranchOptions = useMemo<IPickerOption[]>(() => {
    return (t360IntegrationStore.takerAndToYouBranches?.to_you_branches || []).map((branch) => ({
      label: formatBranchLabel(branch.name, branch.formated_address),
      value: branch.id,
      data: branch,
      disabled: branch.taker_branch_id !== null,
      is_new_select: false,
    }));
  }, [t360IntegrationStore.takerAndToYouBranches?.to_you_branches]);

  const selectedToYouBranch =
    process.env.NODE_ENV !== RELEASES.PRODUCTION
      ? toYouBranchOptions.find(
          (option) =>
            option.data?.taker_branch_id !== null &&
            (option.data?.taker_branch_id === takerBranch.id || option.data?.taker_branch_id === takerBranch.external_id)
        ) ?? null
      : toYouBranchOptions.find((option) => option.data?.taker_branch_id !== null && option.data?.taker_branch_id === takerBranch.id) ?? null;

  const isPreselectedFromAPI: boolean = selectedToYouBranch?.data.taker_branch_id && !selectedToYouBranch.data.is_new_select;

  if (selectedToYouBranch && isPreselectedFromAPI) {
    return <ToYouDisabledPicker selectedToYouBranch={selectedToYouBranch} />;
  }

  return <ToYouEnabledPicker selectedToYouBranch={selectedToYouBranch} toYouBranchOptions={toYouBranchOptions} takerBranch={takerBranch} />;
});

export default ToYouPicker;
